/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import styled from 'styled-components'
import { Flex } from 'particles'
/* ------------------------------- Component -------------------------------- */
export default props => <Flex {...props}/>


// WEBPACK FOOTER //
// ./src/interface/containers/fields/FieldCollectionWrapper/index.js